module.exports = __webpack_public_path__ + "static/img/to.79354e72.svg";